<div class="rm-header">
  <span class="">Phone 2FA Verification</span>
</div>
<div class="container">
  <mat-dialog-content class="mat-typography">
     <!-- <span>You are about to apply Multi-Factor Authentication (MFA) to your account. On your next login you will be prompted to input a code sent to the phone number below.</span> -->
    <p>
      We have sent a verification code to the phone number 
      <span style="color: dodgerblue">{{ data.countryCode + data.mobile }}</span>.  
      Please allow a few minutes for the SMS to arrive.
    </p>

    <p>
      If it doesn't arrive, after 10 minutes, please check that your phone number is correct and request a new code.  It is possible for SMS messages to be delayed or blocked by your mobile carrier. If you continue to have issues receiving the code, please contact support.
    </p>
    <div style="padding-bottom: 10px;">
      <app-code-input [loading]="loading"
                      (onPasteError)="pasteError('Phone Code Error: ', $event);"
                      (onReset)="dialogRef.close()"
                      (onNext)="confirm($event)"
                      [backTitle]="'Cancel'"
                      [nextTitle]="'Verify Phone Number'"
      >
        <span>We sent a code via SMS to 
          <span style="color: dodgerblue">{{ data.countryCode + data.mobile }}</span>, 
          please enter the code above to verify your phone number.
        </span>
      </app-code-input>
    </div>
  </mat-dialog-content>
</div>


